import { arrayMove } from '@dnd-kit/sortable';
import React from 'react';
import { handleAddRenderElement } from 'utils/helpers';
import ContextDnD from './components/Context';
import Droppable from './components/Droppable';

export type SetItemsProps = {
  newItems: any[];
  oldIndex: number;
  newIndex: number;
}

type DragDropProps = {
  items: any[];
  children: (item: any) => React.ReactNode; // Change to function type
  setItems: ({ newItems, oldIndex, newIndex }: SetItemsProps) => void;
  orientation?: 'horizontal' | 'vertical' | 'sorting' | 'swap';
  showRenderElement?: boolean;

}
function DragDrop({ items, children, setItems, orientation = 'vertical', showRenderElement = false }: DragDropProps) {

  const handleDragEnd = (event: any) => {
    const { active, over } = event;
    if (over && active.id !== over.id) {
      const oldIndex = items.findIndex((item) => item.id === active.id);
      const newIndex = items.findIndex((item) => item.id === over.id);
      const newOrder = arrayMove(items, oldIndex, newIndex);
      setItems({ newItems: newOrder, oldIndex, newIndex });
    }

  };
  return <ContextDnD onDragEnd={handleDragEnd} orientation={orientation}>
    <Droppable items={items} orientation={orientation}>
      {items.map((item) => (
        <React.Fragment key={item.id}>
          {children(item)}
        </React.Fragment>
      ))}
      {showRenderElement && <div id="addRenderElement">{handleAddRenderElement(8000) as any} </div>}
    </Droppable>

  </ContextDnD>
}

export default DragDrop;